import script from "./BottomSheet.vue?vue&type=script&setup=true&lang=ts"
export * from "./BottomSheet.vue?vue&type=script&setup=true&lang=ts"

import "./BottomSheet.vue?vue&type=style&index=0&id=7b7c978a&lang=less"

const __exports__ = script;

export default __exports__